import { SINGLE_NUMERIC } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const pan: EffectEntry = {
  kind: 'pan',
  category: 'effect',
  family: 'spatial',
  doc: 'stereo position: 0 full L, 0.5 center, 1 full R',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('pan', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('pan', 'fromAst'),
};
